/* eslint-disable */
// src/components/PrivateRoute.js

/* 
 * Protege rutas: si no hay sesión, redirige a SignIn.
 * Envuelve Route y renderiza Outlet sólo si el usuario está autenticado.
 */

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import { hasRoleAccess } from "utils/auth";

const PrivateRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/authentication/sign-in" />;
  if (!hasRoleAccess(allowedRoles)) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
};

PrivateRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};

PrivateRoute.defaultProps = {
  allowedRoles: [],
};

export default PrivateRoute;
